var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81489 4.214L1.27993 2.93732C0.562734 1.22574 2.36087 -0.45491 4.02016 0.376124L10.0822 3.41219C11.5431 4.1439 11.5577 6.22382 10.1072 6.97596L3.82222 10.2348C2.18133 11.0856 0.363313 9.44598 1.04077 7.72625L1.83111 5.71998C2.02214 5.23505 2.01632 4.6947 1.81489 4.214Z",
    fill: "#FFB801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeVector);
export default __webpack_public_path__ + "static/media/orange-vector.5e27058f57fd67d830c7c0bef744e5f1.svg";
export { ForwardRef as ReactComponent };